import type { IntlKey } from 'locales';

export const DISCOVER_DEFAULT_TECHNICAL_ERROR_KEY: IntlKey = 'discover.fetchData.error';
